import { Component, HostListener, inject, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BarController, BarElement, Chart } from 'chart.js';
import { DataInputPlanDevices } from 'src/app/models/DataInputPlanDevices.model';
import { PlanDeviceDTO } from 'src/app/models/PlanDeviceDTO.model';
import { AddDeviceService } from 'src/app/services/add-device.service';
import { SimpleRequestDTO } from 'src/app/shared/models/SimpleRequest';
import { UserRequestDTO } from 'src/app/shared/models/UserRequestDto';
import { LinearScale, CategoryScale } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { TDeviceUsageDTO } from 'src/app/models/TDeviceUsageDTO.model';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { ResponseDataFile } from 'src/app/shared/models/ApiResponse';
import { saveAs } from 'file-saver';
import { SimpleRequestLongList } from 'src/app/shared/models/SimpleRequestLongList';
import { InventoryService } from 'src/app/services/inventory.service';
import { DeviceDTO } from 'src/app/models/DeviceDTO.model';
import { PaginationService } from 'src/app/shared/services/pagination.service';
import { PlanAvailableDTO } from 'src/app/models/PlanAvailableDTO.model';
import { TableColumn } from 'src/app/models/TableColumn';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableControlComponent, TButtonAction } from '../../../shared/controls/table-control/table-control.component';
import { TooltipDirective } from '../../../directives/tooltip.directive';
import { ConsumptionViewComponent } from '../consumption-view/consumption-view.component';
import { ValidatePermissionsService } from '../../../shared/services/validate-permissions.service';
declare var bootstrap: any;

@Component({
    selector: 'app-list-plan-devices',
    templateUrl: './list-plan-devices.component.html',
    styleUrls: ['./list-plan-devices.component.css'],
    imports: [
        CommonModule,
        FormsModule,
        TableControlComponent,
        TooltipDirective,
        ConsumptionViewComponent
    ]
})
export class ListPlanDevicesComponent {
  public usageData: TDeviceUsageDTO = null!;

  @Input() customerDataInput: DataInputPlanDevices = {} as DataInputPlanDevices;
  devicesPlan: PlanDeviceDTO[] = [];
  simsAvailables: DeviceDTO[] = [] as DeviceDTO[];
  simsAssigned: DeviceDTO[] = [] as DeviceDTO[];
  filteredSimsAvailables: DeviceDTO[] = [] as DeviceDTO[];
  filteredList: PlanDeviceDTO[] = [];
  filterValue: string = 'option1';
  currentPage: number = 1;
  totalPages: number = 0;
  totalPagesAvailables: number = 0;
  pagesToShow: number = 5;
  textoBusqueda: string = '';
  recordsPerPage: number = 10;
  recordsPerPageAvailables: number = 10;
  pagesToShowAvailables: number = 5;
  currentPageAvailables: number = 1;
  alert: Alert = {} as Alert;
  textoBusquedaAvailables: string = '';
  originalSimsAvailables: DeviceDTO[] = [] as DeviceDTO[];
  isAnyCheckboxSelected: boolean = false;
  informationFilters: string = 'Please select the start and end dates for the report query.';
  fromDate?: string = undefined;
  toDate?: string = undefined;

  public permissionsService = inject(ValidatePermissionsService);


  isFilteredByStatus: boolean = false;
  originalPlans: PlanDeviceDTO[] = [];
  selectedPlanDev: PlanDeviceDTO = {} as PlanDeviceDTO;
  isConfirmationModalOpen: boolean = false;
  customerData: any;
  userRequestDTO: UserRequestDTO = {
    userId: undefined,
  };

  devicePlanUpdate: PlanDeviceDTO = {} as PlanDeviceDTO;

  deviceName?: string = '';
  deviceName2?: string = '';
  phoneNumber?: string = '';
  iccid?: string = '';
  mtn?: string = '';
  imei?: string = '';
  modemType?: string = '';
  serialNumber?: string = '';
  custom1?: string = '';
  custom2?: string = '';
  activationDate?: string = undefined;
  ip?: string = '';
  ratePlan?: string = '';
  fieldsCompleted?: boolean = false;
  fieldsCompletedFilter?: boolean = false;
  masterdataRequestDTO: MasterdataRequestDTO = {
    idMaster: 1,
  };
  originatedFrom?: string = '';

  isPrimaryDevice?: boolean = false;

  simpleDataRequestLong: SimpleRequestDTO = {} as SimpleRequestDTO;
  simpleDataRequestLongList: SimpleRequestLongList = {} as SimpleRequestLongList;
  monthlyConsumption: number[] = [];
  rangeMonts: string[] = [];

  columns: TableColumn[] = [
    {
      key: 'primaryDevice', header: 'Primary', format: {
        type: 'boolean',
        trueDisplay: 'True',
        falseDisplay: 'False',
      }
    },
    { key: 'carrierName', header: 'Carrier' },
    { key: 'nameCustomer', header: 'Customer Assigned', width: 250 },
    { key: 'usageOnPeriod', header: 'Usage MB' },
    { key: 'iccid1', header: 'ICCID' },
    { key: 'imei', header: 'IMEI' },
    { key: 'modemType', header: 'Modem Type' },
    { key: 'serialNumber', header: 'Serial Number' },
    { key: 'ipAddress', header: 'IP' },
    { key: 'deviceName', header: 'Username' },
    { key: 'deviceName2', header: 'Username 2' },
    { key: 'custom1', header: 'Custom field 1' },
    { key: 'custom2', header: 'Custom field 2' },
    { key: 'zipCode', header: 'MDN Zip Code' },
    { key: 'nameRatePlan', header: 'Rate Plan', width: 250 },
    { key: 'idAssignedTo', header: 'Assigned to', width: 250 },
    { key: 'dateAssignedString', header: 'Date Assigned' },
    { key: 'costCode', header: 'Cost Code' },
    { key: 'firstName', header: 'First Name', width: 250 },
    { key: 'lastName', header: 'Last Name', width: 250 },

    { key: 'activationDate', header: 'Activation Date - Linkworx', format: { type: 'date', dateFormat: 'MM/dd/yyyy', } },
    { key: 'carrierActivationDate', header: 'Activation Date - Carrier', format: { type: 'date', dateFormat: 'MM/dd/yyyy', } },

    { key: 'deactivationDate', header: 'Deactivation Date', format: { type: 'date', dateFormat: 'MM/dd/yyyy', } },
    { key: 'suspensionDate', header: 'Suspension Date', format: { type: 'date', dateFormat: 'MM/dd/yyyy', } },

    { key: 'originatedFrom', header: 'Originated From', width: 250 },
    { key: 'mdn', header: 'MDN' },
    { key: 'nameStatus', header: 'Status' },
  ];

  actionButtons: TButtonAction[] = [
    { label: 'edit', class: 'primary', icon: 'bi bi-pencil' },
    { label: 'archive', class: 'danger', icon: 'bi bi-archive', hidden: () => !this.permissionsService.isAdmin },

  ];

  allDevicesPlan: PlanDeviceDTO[] = [];

  viewArchivedDevices: boolean = false;
  showActions: boolean = true;



  constructor(
    private addDeviceService: AddDeviceService,
    private alertService: AlertService,
    private inventoryService: InventoryService,
    public paginationService: PaginationService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    Chart.register(
      BarController,
      BarElement,
      CategoryScale,
      LinearScale,
      ChartDataLabels
    );

    this.simpleDataRequestLong.id = this.customerDataInput.planID;
    this.addDeviceService
      .getDevicesPlanByIdPlan(this.simpleDataRequestLong)
      .subscribe(
        ({ StatusCode, Message, Data }) => {
          if (Data != null) {
            this.HandleGetListDevicesPlan(Data);
          } else {
            this.HandleGetError(StatusCode);
          }
        },
        (error) => {
          this.alert = {
            alertMessage: 'Unexpected error. Please try again later.',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000,
          };
          this.alertService.updateAlertState(this.alert);
        }
      );

    this.addDeviceService
      .getAllUsagesByIdPlan(this.simpleDataRequestLong)
      .subscribe(
        ({ StatusCode, Message, Data }) => {
          if (Data != null) {
            this.usageData = Data
          } else {
            this.HandleGetError(StatusCode);
          }
        },
        (error) => {
          this.alert = {
            alertMessage: 'Unexpected error. Please try again later.',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000,
          };
          this.alertService.updateAlertState(this.alert);
        }
      );
  }

  onAction(event: { action: string; item: PlanDeviceDTO }): void {

    switch (event.action) {
      case 'edit':
        this.setUpdateDevice(event.item);
        break;
      case 'archive':
        this.selectedPlanDev = event.item;
        const modalArchive = new bootstrap.Modal("#modalArchive");
        modalArchive.show();
        //this.setArchivedSim(event.item)
        break;
    }
  }



  HandleGetError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000,
    };
    this.alertService.updateAlertState(this.alert);
  }

  HandleGetListDevicesPlan(devicesPlan: PlanDeviceDTO[]) {
    this.allDevicesPlan = devicesPlan;

    this.devicesPlan = devicesPlan.filter((item) => item.aStatus === 1);

    this.simsAssigned = devicesPlan
      .filter((sim) => sim.aStatus !== 2) // Filtrar los que tienen status diferente de 2
      .map((sim) => ({
        devID: sim.aDeviceId,
        iccid: sim.iccid1,
        nameRatePlan: sim.nameRatePlan,
        mdn: sim.mtn,
        imei: sim.imei,
        firstName: sim.firstName,
        lastName: sim.lastName,
        costCode: sim.costCode,
        checked: true,
      }));

    this.filteredList = this.devicesPlan.slice();
    this.originalPlans = this.devicesPlan.slice();
    this.devicesPlan = this.originalPlans.filter(
      (plan) => plan.aStatus === 0 || plan.aStatus === 1
    );
    this.totalPages = Math.ceil(this.devicesPlan.length / 10);

    this.inventoryService.getListSimsAvailables().subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetSimsAvailables(Data)
          : this.HandleGetError(StatusCode),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000,
        };
        this.alertService.updateAlertState(this.alert);
      }
    );
  }



  toggleStatus(event: any, plan: PlanDeviceDTO) {
    plan.aStatus = event.target.checked ? 1 : 0;
    const indice = this.originalPlans.findIndex(
      (p) => p.aPlanDeviceId === plan.aPlanDeviceId
    );
    if (indice !== -1) {
      this.originalPlans[indice].aStatus = plan.aStatus;
    }
  }

  openConfirmationModal(plan: any) {
    this.selectedPlanDev = plan;
    this.isConfirmationModalOpen = true;
  }

  async closeConfirmationModal() {
    this.isConfirmationModalOpen = false;
    //location.reload();
  }

  // Metodo para actualizar el estado de un cliente
  updatePlanDeviceStatus(confirmed: boolean) {
    if (confirmed) {
      this.selectedPlanDev.aStatus = this.selectedPlanDev.aStatus === 1 ? 2 : 1;
      this.addDeviceService
        .updatePlanDeviceStatus(this.selectedPlanDev)
        .subscribe(
          ({ StatusCode, Message, Data }) => {
            if (Data != null) {
              this.HandleUpdateCustomerStatus(Data);
            } else {
              this.HandleUpdateCustomerStatusError(StatusCode);
            }
          },
          (error) => {
            console.error('Unexpected error fetching customer list:', error);
          }
        );
    } else {
      this.addDeviceService
        .getDevicesPlanByIdPlan(this.simpleDataRequestLong)
        .subscribe(
          ({ StatusCode, Message, Data }) => {
            if (Data != null) {
              this.HandleGetListDevicesPlan(Data);
            } else {
              this.HandleGetError(StatusCode);
            }
          },
          (error) => {
            this.alert = {
              alertMessage: 'Unexpected error. Please try again later.',
              alertType: 'alert alert-danger',
              alertCenter: false,
              alerTitle: '',
              duration: 3000,
            };
            this.alertService.updateAlertState(this.alert);
          }
        );
    }
  }

  HandleUpdateCustomerStatusError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000,
    };
    //localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(this.alert);
  }

  async HandleUpdateCustomerStatus(customer: boolean) {
    this.alert = {
      alertMessage: 'Device plan status updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000,
    };

    this.alertService.updateAlertState(this.alert);
  }

  async HandleUpdatePlanDevice(customer: boolean) {
    this.alert = {
      alertMessage: 'Device updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000,
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(this.alert);

    const secondModalElement = document.getElementById('modalUpdatePlan');
    if (secondModalElement) {
      const secondModal = bootstrap.Modal.getInstance(secondModalElement);
      secondModal.hide(); // Cerrar la segunda modal
    }

    this.addDeviceService
      .getDevicesPlanByIdPlan(this.simpleDataRequestLong)
      .subscribe(
        ({ StatusCode, Message, Data }) => {
          if (Data != null) {
            this.HandleGetListDevicesPlan(Data);
          } else {
            this.HandleGetError(StatusCode);
          }
        },
        (error) => {
          this.alert = {
            alertMessage: 'Unexpected error. Please try again later.',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000,
          };
          this.alertService.updateAlertState(this.alert);
        }
      );
  }

  updatePlanDev(customer: PlanDeviceDTO) {
    // this.router.navigate(['/plan-devices'], {
    //   relativeTo: this.route,
    //   state: { customerData: customer },
    // });
  }

  updateDevice(confirmation: boolean) {
    if (confirmation) {

      this.devicePlanUpdate.aDeviceId = this.selectedPlanDev.aDeviceId;
      this.devicePlanUpdate.aPlanDeviceId = this.selectedPlanDev.aPlanDeviceId;
      this.devicePlanUpdate.iccid1 = this.iccid;
      this.devicePlanUpdate.mtn = this.mtn;
      this.devicePlanUpdate.imei = this.imei;
      this.devicePlanUpdate.modemType = this.modemType;
      this.devicePlanUpdate.serialNumber = this.serialNumber;
      this.devicePlanUpdate.deviceIpAddress = this.ip;
      this.devicePlanUpdate.deviceName = this.deviceName;
      this.devicePlanUpdate.deviceName2 = this.deviceName2;

      this.devicePlanUpdate.originatedFrom = this.originatedFrom;

      this.devicePlanUpdate.custom1 = this.custom1;
      this.devicePlanUpdate.custom2 = this.custom2;
      this.devicePlanUpdate.primaryDevice = this.isPrimaryDevice;
      this.devicePlanUpdate.aDevRatePlan = this.ratePlan;
      this.devicePlanUpdate.activationDate =
        this.activationDate !== undefined
          ? new Date(this.activationDate)
          : undefined;

      this.addDeviceService.updatePlanDevice(this.devicePlanUpdate).subscribe(
        ({ StatusCode, Message, Data }) => {
          if (Data != null) {
            this.HandleUpdatePlanDevice(Data);
          } else {
            this.HandleUpdateCustomerStatusError(StatusCode);
          }
        },
        (error) => {
          this.alert = {
            alertMessage: 'Unexpected error. Please try again later.',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000,
          };
          //localStorage.setItem('AlertObject', JSON.stringify(this.alert));
          this.alertService.updateAlertState(this.alert);
        }
      );
    } else {
      //location.reload();
    }
  }

  checkFields() {
    if (this.iccid == '') {
      this.fieldsCompleted = false;
    } else {
      this.fieldsCompleted = true;
    }
  }

  checkFieldsFilter() {
    if (this.fromDate && this.toDate) {
      if (new Date(this.fromDate) >= new Date(this.toDate)) {
        this.toDate = "";
        this.fieldsCompletedFilter = false;
      }
      else {
        this.fieldsCompletedFilter = true;
      }
    }
    else {
      this.fieldsCompletedFilter = false;
    }
  }

  async handleUpdatePlanSuccess(data: any) {
    this.alert = {
      alertMessage: 'Device updated successfully.',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000,
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(this.alert);
    location.reload();
  }

  setUpdateDevice(devicePlan: PlanDeviceDTO) {


    this.router.navigate(['/customers/device/update', devicePlan.iccid1],);
  }

  exportToExcelListPlanDevices() {
    let planDeviceIdList: number[] = [];

    if (this.filteredList.length === this.devicesPlan.length) {
      planDeviceIdList = [];
    } else {
      planDeviceIdList = this.filteredList
        .filter((device: PlanDeviceDTO) => device.aPlanDeviceId !== undefined)
        .map((device: PlanDeviceDTO) => device.aPlanDeviceId as number);
    }

    this.simpleDataRequestLongList.id = this.simpleDataRequestLong.id;
    this.simpleDataRequestLongList.listIds = planDeviceIdList;

    this.addDeviceService
      .exportToExcelListPlanDevices(this.simpleDataRequestLongList)
      .subscribe(
        (response: ResponseDataFile) => {
          if (response) {
            this.handleDownload(response);
          } else {
            this.handleGetFileError();
          }
        },
        (error) => {
          console.error('Error al exportar el archivo Excel:', error);
        }
      );
  }

  exportToExcelListPlanDevicesAnnual(confirmation: boolean) {
    if (confirmation) {
      let planDeviceIdList: number[] = [];

      if (this.filteredList.length === this.devicesPlan.length) {
        planDeviceIdList = [];
      } else {
        planDeviceIdList = this.filteredList
          .filter((device: PlanDeviceDTO) => device.aPlanDeviceId !== undefined)
          .map((device: PlanDeviceDTO) => device.aPlanDeviceId as number);
      }

      this.simpleDataRequestLongList.id = this.simpleDataRequestLong.id;
      this.simpleDataRequestLongList.listIds = planDeviceIdList;
      this.simpleDataRequestLongList.fromDate = this.fromDate !== undefined ? new Date(this.fromDate) : undefined;
      this.simpleDataRequestLongList.toDate = this.toDate !== undefined ? new Date(this.toDate) : undefined;

      this.addDeviceService
        .exportToExcelListPlanDevicesAnnual(this.simpleDataRequestLongList)
        .subscribe(
          (response: ResponseDataFile) => {
            if (response) {
              this.handleDownload(response);
            } else {
              this.handleGetFileError();
            }
          },
          (error) => {
            console.error('Error al exportar el archivo Excel:', error);
          }
        );
    }
  }

  exportToExcelListPlanDevicesConsolidated() {

    
    let planDeviceIdList: number[] = [];

    if (this.filteredList.length === this.devicesPlan.length) {
      planDeviceIdList = [];
    } else {
      planDeviceIdList = this.filteredList
        .filter((device: PlanDeviceDTO) => device.aPlanDeviceId !== undefined)
        .map((device: PlanDeviceDTO) => device.aPlanDeviceId as number);
    }

    this.simpleDataRequestLongList.id = this.simpleDataRequestLong.id;
    this.simpleDataRequestLongList.listIds = planDeviceIdList;

    this.addDeviceService
      .exportToExcelListPlanDevicesConsolidated(this.simpleDataRequestLongList)
      .subscribe(
        (response: ResponseDataFile) => {
          if (response) {
            this.handleDownload(response);
          } else {
            this.handleGetFileError();
          }
        },
        (error) => {
          console.error('Error al exportar el archivo Excel:', error);
        }
      );
  }

  private handleDownload(data: ResponseDataFile) {
    const byteCharacters = atob(data.Data.fileContents);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: data.Data.contentType });
    saveAs(blob, data.Data.fileDownloadName || 'export.xlsx');

    this.alert = {
      alertMessage: 'File generated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000,
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(this.alert);
  }

  private handleGetFileError() {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000,
    };
    this.alertService.updateAlertState(this.alert);
  }

  // Método para abrir la segunda modal desde la primera modal
  openConfirmationModalUpdate() {
    // Abrir el segundo modal (Confirmation Update)
    const secondModalElement = document.getElementById('confirmationUpdate');
    if (secondModalElement) {
      const secondModal = new bootstrap.Modal(secondModalElement);
      secondModal.show();
    }
  }

  handleGetSimsAvailables(simsListAvailables: DeviceDTO[]) {
    // Mapear sims disponibles
    this.simsAvailables = simsListAvailables.map((device) => ({ ...device }));

    // Marcar los sims asignados como checked
    this.simsAssigned.forEach((sim) => {
      sim.checked = true;
    });

    // Concatenar los sims asignados con los disponibles
    this.simsAvailables = this.simsAvailables.concat(
      this.simsAssigned.map((sim) => ({ ...sim }))
    );

    // Ordenar para que los elementos marcados estén primero
    this.simsAvailables.sort((a, b) => {
      if (a.checked === b.checked) {
        return 0; // Mantener el orden relativo si ambos son iguales
      }
      return a.checked ? -1 : 1; // Los 'checked' van al principio
    });

    // Guardar copia original
    this.originalSimsAvailables = this.simsAvailables.slice();

    // Calcular páginas totales
    this.totalPagesAvailables = Math.ceil(this.simsAvailables.length / 10);
  }

  assignSims(confirmed: boolean) {
    if (confirmed) {
      // Crear una lista de objetos PlanDeviceDto
      let listPlanDev: PlanDeviceDTO[] = this.simsAvailables.map((device) => ({
        aDeviceId: device.deviceId,
        aUserPlanId: this.customerDataInput.planID,
        aStatus: 1,
        checked: device.checked,
      }));

      this.addDeviceService.addDevicesToPlan(listPlanDev).subscribe(
        ({ StatusCode, Message, Data }) =>
          Data != null
            ? this.handleAddSimsToPlan(Data)
            : this.HandleGetError(StatusCode),
        (error) => {
          this.alert = {
            alertMessage: 'Unexpected error. Please try again later.',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000,
          };
          this.alertService.updateAlertState(this.alert);
        }
      );
    }
  }

  handleAddSimsToPlan(StatusCode: boolean) {
    this.alert = {
      alertMessage: 'Sims added successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000,
    };

    this.alertService.updateAlertState(this.alert);
    location.reload();
  }

  // onsereachChangeAvailables(): void {
  //   this.updatePaginationAvailables();
  // }

  // updatePaginationAvailables(): void {
  //   if (!this.textoBusquedaAvailables) {
  //     this.totalPagesAvailables = Math.ceil(
  //       this.simsAvailables.length / this.recordsPerPageAvailables
  //     );
  //   }

  //   const searchCriteria = this.textoBusquedaAvailables
  //     .split(',')
  //     .map((criterio) => criterio.trim().toLowerCase());

  //   const filteredList = this.simsAvailables.filter((item) =>
  //     this.camposBusquedaAvailables.some((field) => {
  //       const fieldValue = (item as any)[field];
  //       // Verificamos si el valor del campo no es undefined o null
  //       if (fieldValue !== undefined && fieldValue !== null) {
  //         return searchCriteria.some((criterio) =>
  //           fieldValue.toString().toLowerCase().includes(criterio)
  //         );
  //       }
  //       return false; // Si es undefined o null, lo ignoramos
  //     })
  //   );

  //   this.totalPagesAvailables = Math.ceil(
  //     filteredList.length / this.recordsPerPageAvailables
  //   );
  //   this.currentPageAvailables = 1;
  // }

  selectAllCheckboxes(event: any): void {
    const isChecked = event.target.checked;
    this.simsAvailables.forEach((sim) => {
      sim.checked = isChecked;
    });
    this.isAnyCheckboxSelected = this.simsAvailables.some((sim) => sim.checked);
  }

  previousPageAvailables() {
    if (this.currentPageAvailables > 1) {
      this.currentPageAvailables--;
    }
  }

  checkboxChanged(): void {
    this.isAnyCheckboxSelected = this.simsAvailables.some((sim) => sim.checked);
  }

  get pageAvailables(): number[] {
    const start = Math.max(
      1,
      this.currentPageAvailables - Math.floor(this.pagesToShowAvailables / 2)
    );
    const end = Math.min(
      this.totalPagesAvailables,
      start + this.pagesToShowAvailables - 1
    );
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  changePageAvailables(page: number) {
    if (page >= 1 && page <= this.totalPagesAvailables) {
      this.currentPageAvailables = page;
    }
  }

  nextPageAvailables() {
    if (this.currentPageAvailables * 10 < this.simsAvailables.length) {
      this.currentPageAvailables++;
    }
  }

  openConfirmationData() {
    const secondModalElement = document.getElementById('confirmationData');
    if (secondModalElement) {
      const secondModal = new bootstrap.Modal(secondModalElement);
      secondModal.show();
    }
  }

  updatePlan(confirmation: boolean) {

    // if(confirmation){
    //   this.userPlanDev.aUserPlanId = this.selectedPlanDev.idusrplndev;
    //   this.userPlanDev.aPlanId = this.planSelected !== undefined ? parseInt(this.planSelected.toString()) : undefined;
    //   this.userPlanDev.aDiscount = this.discount != null ? parseFloat(this.discount.toString().replace(/[\$,]/g, '').replace(/\,/g, '.')) : undefined;
    //   this.userPlanDev.aTypeDiscount = this.typeDiscount;
    //   this.userPlanDev.aValidFrom = this.dateValidFrom !== undefined ? new Date(this.dateValidFrom) : undefined;
    //   this.userPlanDev.aValidUntil = this.dateValidUntil !== undefined ? new Date(this.dateValidUntil) : undefined;
    //   this.userPlanDev.aDescription = this.description;
    //   this.userPlanDev.aDeviceId = undefined;
    //   this.userPlanDev.aUserId = this.selectedPlanDev.userId;
    //   this.userPlanDev.renovationChecked = this.renovationChecked;
    //   this.userPlanDev.transferDataChecked = this.transferChecked;
    //   this.userPlanDev.prorationEnd = this.prorationFinal;

    //   this.assignPlanService.updateUserPlan(this.userPlanDev).subscribe(
    //     ({ StatusCode, Message, Data }) =>
    //       Data != null
    //         ? this.handleUpdatePlanSuccess(Data)
    //         : this.handleError(StatusCode),
    //     (error) => {
    //       this.clearFields();
    //     }
    //   );
    // }
    // else{
    //   this.clearChecks();
    // }
  }

  minDate(): string | null {
    if (this.fromDate) {
      const minDate = new Date(this.fromDate);
      minDate.setDate(minDate.getDate() + 1);
      return minDate.toISOString().split('T')[0];
    }
    return null;
  }



  onCheckboxChange(event: Event): void {

    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.devicesPlan = this.allDevicesPlan.filter(ticket => ticket.aStatus === 2);
      this.showActions = false;

    } else {
      this.showActions = true;
      this.devicesPlan = this.allDevicesPlan.filter(ticket => ticket.aStatus === 1);
    }
  }

  onFilteredItemsChange(data: PlanDeviceDTO[]): void {

    
    this.filteredList = data;

  }
}
